import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { User } from '@models/user';

import { useToast } from '@hooks/useToast';
import { updateUser } from './api';

type UpdateUserParams = {
  id: string;
  user: User;
};

export function useUpdateUser() {
  const queryClient = useQueryClient();
  const toast = useToast();

  return useMutation<User, unknown, UpdateUserParams>({
    mutationFn: (payload) => updateUser(payload.id, payload.user),
    onSuccess: () => {
      // Invalidate and refetch
      queryClient.invalidateQueries({ queryKey: ['users'] });
      queryClient.invalidateQueries({ queryKey: ['user'] });
      toast.success('User updated successfully');
    },
  });
}
